import { logError } from './logger';

const learnMoreClick = affirmButtonRef => {
  try {
    const affirmWrapper = affirmButtonRef?.current;

    // Find first link or button in affirm HTML
    const affirmLinkOrButton = affirmWrapper?.querySelector?.('a,button');

    if (affirmLinkOrButton?.click) {
      // If a link or button is found, click it
      affirmLinkOrButton.click?.();
    } else {
      // If no link or button is found, throw an error
      throw new Error('No link or button found in affirm HTML');
    }
  } catch (err) {
    logError(
      err,
      {
        type: 'affirm',
      },
      {
        affirm: !!window.affirm,
        firstChild: !!affirmButtonRef?.current?.firstChild,
      }
    );
  }
};

export default learnMoreClick;
